export const SortProperties = {
  UPDATED_AT: 'updatedAt',
  TYPE: 'type',
} as const
